export function setState(state, keyValue = []) {
  if (!Array.isArray(keyValue)) {
    return;
  }
  state[keyValue[0]] = keyValue[1];
}
